module.exports = __webpack_public_path__ + "img/icon-broken-contract-green.6c591879.svg";